'use client';

import { Footer } from '@lmn/contenthub-shared/components';
import type { FooterProps } from '@lmn/contenthub-shared/components';

interface ContentHubFooterProps {
  footerProps: FooterProps;
}

/**
 * Client component wrapper for Content Hub Footer
 * Receives props generated server-side from CNT_CONTESTS data
 * 
 * Per Content Hub documentation (SSR pattern):
 * - Footer props are fetched server-side using getFooterProps()
 * - Props are based on contest data (brand, country, lang from CNT_CONTESTS table)
 * - Component is client-side because Footer uses React Context internally
 * - DynamicLmnDsThemeProvider must wrap the app at a higher level (done in providers.tsx)
 * 
 * This follows the Next.js App Router pattern:
 * - Server Component (page.tsx) fetches data and generates props
 * - Client Component (this) receives props and renders Content Hub Footer
 */
export function ContentHubFooter({ footerProps }: ContentHubFooterProps) {
  // Don't render if props are missing or invalid
  if (!footerProps || (typeof footerProps === 'object' && Object.keys(footerProps).length === 0)) {
    return null;
  }
  
  return <Footer {...footerProps} />;
}

